import React from 'react'
import I18n from '../../../resources/i18n/I18n'
import PatrimonyItem from './item/PatrimonyItem'

const PatrimonyEditList = ({
  patrimonies,
  selectedItems,
  expandedItems,
  onSelectionChange,
  onToggleExpand,
  type,
  userAgencies,
  associatedAgencies = [],
}) => {
  return (
    <div className="tree-items">
      {patrimonies.length > 0 ? (
        patrimonies.map((patrimony) => (
          <PatrimonyItem
            key={patrimony.id}
            patrimony={patrimony}
            type={type}
            userAgencies={userAgencies}
            expandedItems={expandedItems}
            selectedItems={selectedItems}
            onToggleExpand={onToggleExpand}
            onSelectionChange={onSelectionChange}
            associatedAgencies={associatedAgencies}
          />
        ))
      ) : (
        <div className="text-muted p-3 bg-white rounded shadow-sm">{I18n.t('NoDataFound')}</div>
      )}
    </div>
  )
}
export default React.memo(PatrimonyEditList)
